module.exports = __webpack_public_path__ + "img/chn-th.e7d8c5d1.png";